/**
 * Merge assignments.first across serial inventory rows in one group
 * (for distribution modal: quantities per soldier / unit).
 *
 * @param {Array<Object>} members - Real inventory rows (same group)
 * @returns {Record<string, Object>} merged `assignments.first` map
 */
export function mergeAssignmentsFirstFromMembers(members) {
  const merged = {};
  if (!Array.isArray(members)) return merged;

  for (const m of members) {
    const first = m?.assignments?.first;
    if (!first || typeof first !== "object") continue;

    for (const [personalNumber, assignment] of Object.entries(first)) {
      if (!assignment || typeof assignment !== "object") continue;
      const qty = Number(assignment.quantity) || 0;

      if (!merged[personalNumber]) {
        merged[personalNumber] = { ...assignment, quantity: qty };
      } else {
        const prev = merged[personalNumber];
        merged[personalNumber] = {
          ...prev,
          quantity: (Number(prev.quantity) || 0) + qty,
          firstName: prev.firstName || assignment.firstName || "",
          lastName: prev.lastName || assignment.lastName || "",
        };
      }
    }
  }

  return merged;
}
